var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.getClass},[(_vm.showButton)?_c('ur-button',{attrs:{"small":"","disabled":_vm.disabled,"text":_vm.buttonText},on:{"click":_vm.onButtonClick}}):_c('span',[_vm._v(_vm._s(_vm.descText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }